import { Typography } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { useContext } from 'react'
import ApplicationContext from '@platform/react/context/application'
import StatusChip from 'ui/Element/Text/StatusChip'

/**
 * Intended to display name and address of the organisation where a person belongs to.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
export const ListItemCellRequestStatus = (classes, props = {}) => {
  const { intl } = useContext(ApplicationContext)
  const {
    status: statusKey,
    statusReason: statusReasonKey,
    modify: { timestamp: modifyTimestamp = '' } = {},
    events,
  } = props
  const [statusReason] = events?.getStatusReason?.(statusReasonKey || -1) || []
  const statusReasonLabel = statusReason?.value
  const modifyDate = modifyTimestamp
    ? intl.getLocaleDate(modifyTimestamp, { dateStyle: 'short' })
    : ''
  const statusLine = statusReasonLabel
    ? `${statusReasonLabel} - ${modifyDate}`
    : modifyDate

  return (
    <>
      <StatusChip
        value={statusKey}
        events={{ onOpen: events?.getStatus }}
        textVariant={'12/bold'}
        rounded={false}
        size={'tiny'}
      />
      <Typography
        variant={'caption'}
        color={'textSecondary'}
        className={classes.row}
      >
        {statusLine}
      </Typography>
    </>
  )
}

export default CellHOC(ListItemCellRequestStatus)
